const items = [
  "Precision Pins",
  "OEM-Grade Bushes",
  "JIC Hydraulics",
  "Rotary Groups",
  "Made in India",
  "Custom Solutions",
];

export const Marquee = () => (
  <div className="marquee" data-testid="editorial-marquee" aria-hidden="true">
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div className="marquee-group" key={copy}>
          {items.map((it, i) => (
            <span className="marquee-item" key={i}>
              {it} <span className="marquee-dot">✦</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
